import {
  EPaymentMethod,
  TShopItem,
  TPaymentItem,
  EPaymentItemType,
} from 'types';

export enum ECommand {
  XReport = 'XReport',
  List = 'List',
  OpenShift = 'OpenShift',
  CloseShift = 'CloseShift',
  RegisterCheck = 'RegisterCheck',
  GetGoodCodeData = 'GetGoodCodeData',
  GetState = 'GetDataKKT',
}

interface IRefundPaymentArgs {
  items: Array<TPaymentItem>;
  sum: number;
  method: EPaymentMethod;
  cash_sum?: number;
  card_sum?: number;
}
export type TRefundPaymentFn = (
  args: IRefundPaymentArgs
) => Promise<IKKMResponse>;

interface ICreatePaymentArgs {
  method: EPaymentMethod;
  items: Array<TShopItem>;
  cardSum?: number;
  cashSum?: number;
  discount?: number;
  availableItems?: Array<{ entity_id: number; entity_type: string }> | null;
  depositSum?: number;
  postPaymentSum?: number;
}
export type TCreatePaymentFn = (
  args: ICreatePaymentArgs
) => Promise<IKKMResponse>;

export interface IOFDState {
  count: number;
  firstErrorDate?: string;
}

export interface ICashboxContext {
  loadKKMs: () => Promise<IKKMListResponse>;
  openWorkShift: () => Promise<IKKMResponse>;
  closeWorkShift: () => Promise<IKKMResponse>;
  refundPayment: TRefundPaymentFn;
  createPayment: TCreatePaymentFn;
  printXReport: () => Promise<IKKMResponse>;
  validateHonestSign: (code: string) => Promise<{
    validate: boolean;
    errorMessage?: string;
  }>;
  OFDState: IOFDState;
}

export enum ECommandStatus {
  SUCCESS,
  IN_PROGRESS,
  ERROR,
  DATA_NOT_FOUND,
}

export interface IKKMResponse {
  Status: ECommandStatus;
  Error: string;
  Message: string;
  IdCommand: string;
  ValidationPR: {
    ValidationResult: boolean;
    ValidationDisabled: boolean;
    DecryptionResult: string;
  };
}

export interface IKKMRequest {
  Command: ECommand;
  InnKkm?: string;
  CashierName?: string;
  KeySubLicensing?: string;
}

export interface IPrintReceiptRequest extends IKKMRequest {
  Command: ECommand.RegisterCheck;
  TaxVariant: TTaxVariantValue;
  Timeout: 15 | 180;
  IsFiscalCheck: true;
  TypeCheck: EReceiptType;
  NumberCopies: number;
  CheckStrings: Array<IFiscalReceiptItem>;
  Cash: number;
  ElectronicPayment: number;
}

export interface IKKM {
  INN: string;
  NameDevice: string;
  TaxVariant: string;
  FN_IsFiscal: boolean;
}
export interface IKKMListResponse extends IKKMResponse {
  ListUnit: Array<IKKM>;
}

export interface IKKMStateResponse extends IKKMResponse {
  Info: {
    OFD_NumErrorDoc: number;
    OFD_DateErrorDoc: string;
  };
}

export type TNDSValue = -1 | 0 | 5 | 7 | 10 | 22 | 110 | 120;
export enum ENDS {
  NO_NDS = 'NO_NDS',
  NDS_0 = 'NDS_0',
  NDS_5 = 'NDS_5',
  NDS_7 = 'NDS_7',
  NDS_10 = 'NDS_10',
  NDS_20 = 'NDS_20',
  NDS_110 = 'NDS_110',
  NDS_120 = 'NDS_120',
}
export type TTaxVariantValue = 0 | 1 | 2 | 5;
export enum ETaxVariant {
  SIMPLE_INCOME = 'SIMPLE_INCOME',
  SIMPLE_INCOME_EXPENSES = 'SIMPLE_INCOME_EXPENSES',
  PATENT = 'PATENT',
  MAIN = 'MAIN',
}

export enum ESignMethod {
  FULL_SETTLEMENT = 4,
}

export enum ESignObject {
  GOOD = 1,
  EXCISE = 2,
  SERVICE = 4,
}

export enum EReceiptType {
  SALE,
  REFUND,
}

export interface IFiscalReceiptItem {
  Register: {
    Name: string;
    Quantity: number;
    Price: number;
    Amount: number;
    Tax: TNDSValue;
    SignMethodCalculation: ESignMethod;
    SignCalculationObject: ESignObject;
    GoodCodeData?: {
      BarCode: string;
    };
  };
}

export interface ISaleItem {
  title: string;
  amount: number;
  price: number;
  totalPrice?: number;
  type: EPaymentItemType;
  sign?: string;
  NDS?: ENDS | null;
  is_excise?: boolean;
}

export enum EGoodCodeType {
  GS1 = 'GS1',
}
export interface IGoodCodeDataRequest extends IKKMRequest {
  Command: ECommand.GetGoodCodeData;
  BarCode: string;
}
export interface IGoodCodeDataResponse extends IKKMResponse {
  DataProductCode: {
    isParsed: boolean;
    ProductCodeType: EGoodCodeType;
  };
}
